import './DatePicker.scss';
import Component from './DatePicker.js';
export default Component;
